import { render, staticRenderFns } from "./preformatted-modal-micro.vue?vue&type=template&id=5b6b43f0&scoped=true&"
import script from "./preformatted-modal-micro.ts?vue&type=script&lang=ts&"
export * from "./preformatted-modal-micro.ts?vue&type=script&lang=ts&"
import style0 from "./preformatted-modal-micro.scss?vue&type=style&index=0&id=5b6b43f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6b43f0",
  null
  
)

export default component.exports